export const API_BASE_URL =
  process.env.REACT_APP_ENV === 'dev'
    ? 'https://api.dev.m-flow.io'
    : process.env.REACT_APP_ENV === 'prod'
      ? 'https://api.m-flow.io'
      : 'http://localhost:8080';

// mcp-server (apps/mcp-server in mflow-msa-mono) has no deployed hostname yet as of this writing —
// it isn't wired into any docker-compose/k8s config, only a local default port (8095, see its
// main.ts). The dev/prod values below follow API_BASE_URL's api(.dev).m-flow.io naming convention
// but are an unconfirmed guess, not something read off real infra — see the "mcp-server base URL"
// entry logged to fe-open-concerns-v3.md. REACT_APP_MCP_BASE_URL is an escape hatch to override
// this without a code change once ops picks a real hostname.
export const MCP_BASE_URL =
  process.env.REACT_APP_MCP_BASE_URL ||
  (process.env.REACT_APP_ENV === 'dev'
    ? 'https://mcp.dev.m-flow.io'
    : process.env.REACT_APP_ENV === 'prod'
      ? 'https://mcp.m-flow.io'
      : 'http://localhost:8095');
